import { query } from '../../utils/query';

export const getSingleNewsRequest = (newsId) => {
  return query({
    uri: `api/v1/admin/news/${newsId}/`
  });
};
